import React from 'react';
import {
  GridColCardContainer,
  GridColCardHeader,
  GridColCardHeaderIcon,
  GridColCardHeaderInfo,
  GridColCardBody,
  GridColCardBodyGrid,
  GridColCardBodyLabel,
  GridColCardBodyValue,
  GridColCardFooter,
  GridColCardFooterLabel,
  GridColCardFooterPrice,
  GridColCardFooterValue,
  GridColCardFooterValueInfo,
  GridColCardFooterButton,
  GridColCardFooterStatus,
  AnularFooterButton
} from './styles';
import { P } from '../Typography/styles';
import { BsPersonCheck, BsArrowRightShort } from 'react-icons/bs';
import { formatData } from '../../helpers/date';
import { formatPrice } from '../../helpers/price';
import { formatPhone, formatIdentification } from '../../helpers/string';
import { useHistory, useLocation } from 'react-router-dom';
import colors from '../../assets/styles/colors';
import redirectToCorrectPage from '../../services/redirectToCorrectPage';
import { exceptionStatus } from '../../helpers/enum';

const GridColCard = ({ item, exception, canalEstado, setShowModalAnular, setIdCreditAnular }) => {
  const history = useHistory();
  const location = useLocation();
  
  return (
    <GridColCardContainer id="card">
      <GridColCardHeader>
        {
          !exception && (
            <GridColCardHeaderIcon>
              <BsPersonCheck size={20} color={colors.bgPrimary} id="person-check-icon" />
            </GridColCardHeaderIcon>
          )
        }
        <GridColCardHeaderInfo>
          <P bold color={colors.textPrimary}>{item.cliente.nombre}</P>
          <P color={colors.textPrimary}>CC. {formatIdentification(item.cliente.identificacion)}</P>
        </GridColCardHeaderInfo>
      </GridColCardHeader>
      <GridColCardBody>
        <GridColCardBodyGrid>
          <GridColCardBodyLabel>Celular</GridColCardBodyLabel>
          <GridColCardBodyValue>{formatPhone(item.cliente.celular)}</GridColCardBodyValue>
        </GridColCardBodyGrid>
        <GridColCardBodyGrid>
          <GridColCardBodyLabel>Correo</GridColCardBodyLabel>
          <GridColCardBodyValue>{item.cliente.email}</GridColCardBodyValue>
        </GridColCardBodyGrid>
        {item.cliente.ciudad && (
          <GridColCardBodyGrid>
            <GridColCardBodyLabel>Ciudad</GridColCardBodyLabel>
            <GridColCardBodyValue>{item.cliente.ciudad.nombre}</GridColCardBodyValue>
          </GridColCardBodyGrid>
        )}
        <GridColCardBodyGrid>
          <GridColCardBodyLabel>Pagaduría</GridColCardBodyLabel>
          <GridColCardBodyValue>{item.pagaduria.nombre}</GridColCardBodyValue>
        </GridColCardBodyGrid>
        <GridColCardBodyGrid>
          <GridColCardBodyLabel>Ult. actualización</GridColCardBodyLabel>
          <GridColCardBodyValue>{formatData(item.fecha)}</GridColCardBodyValue>
        </GridColCardBodyGrid>
        <GridColCardBodyGrid>
          <GridColCardBodyLabel>Monto solicitado</GridColCardBodyLabel>
          <GridColCardBodyValue>$ {!item.totalCredito ? 0 : formatPrice(parseInt(item.totalCredito))}</GridColCardBodyValue>
        </GridColCardBodyGrid>
      </GridColCardBody>
      <GridColCardFooter>
        <GridColCardFooterLabel color={colors.textPrimary}>Cuota mensual aproximada</GridColCardFooterLabel>
        <GridColCardFooterPrice>
          <GridColCardFooterValue>
            $ {formatPrice(parseInt(item.cuota))}
          </GridColCardFooterValue>
          <GridColCardFooterValueInfo>
            Tasa {item.tasa}% MV
            {['digicredito', 'adjuntar','validacion_identidad'].includes(canalEstado) && (
            <GridColCardFooterButton id="select-item" onClick={() => redirectToCorrectPage(history, item, location)}>
              <BsArrowRightShort size={22} color={colors.textPrimary} id="plus-icon" />
            </GridColCardFooterButton>
            )}
            {canalEstado == "anular" && (
            <AnularFooterButton id="select-item" onClick={() => {setShowModalAnular(true);setIdCreditAnular(item);}}>
              Anular
            </AnularFooterButton>
            )}
          </GridColCardFooterValueInfo>
        </GridColCardFooterPrice>
      </GridColCardFooter>
      {exception && (
        <GridColCardFooterStatus background={exceptionStatus[exception].background}>
          {exceptionStatus[exception].nombre}
        </GridColCardFooterStatus>
      )}
    </GridColCardContainer>
  )
}

export default GridColCard;
